import { Group } from '@chakra-ui/react';
import type { ReactNode } from 'react';

const FormActions = ({ children }: { children: ReactNode }) => (
    <Group gap='2' flexWrap='wrap' justifyContent='flex-end' w='full' pt='4'>
        {children}
    </Group>
);

export default FormActions;
